import { SalesType } from '../../../types/redux';
import * as epe from './epeConfig';
import * as kpp from './kppConfig';
import * as kpe from './kpeConfig';
import * as keh from './kehConfig';
import * as test from './testConfig';

export const getForms = (salesType: SalesType) => {
	switch (salesType) {
		case SalesType.TEST:
			return test.forms;
		case SalesType.KPP:
			return kpp.forms;
		case SalesType.KPE:
			return kpe.forms;
		case SalesType.KEH:
			return keh.forms;
		case SalesType.EPK:
			return epe.forms;
		case SalesType.EPH:
			return epe.forms;
		default:
			console.warn('No valid forms found!', 'Sales Type:', salesType);
			return [''];
	}
};

export const getSteps = (salesType: SalesType) => {
	switch (salesType) {
		case SalesType.TEST:
			return test.steps;
		case SalesType.KPP:
			return kpp.steps;
		case SalesType.KPE:
			return kpe.steps;
		case SalesType.KEH:
			return keh.steps;
		case SalesType.EPK:
			return epe.steps;
		case SalesType.EPH:
			return epe.steps;
		default:
			console.warn('No valid steps found!', 'Sales Type:', salesType);
			return [''];
	}
};
